{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Download (v2)"
      }
    }
  },
  "subHeader": {
    "backToMyBookings": "Exit trip",
    "backToMyBookingsAria": "Exit trip"
  },
  "reviewPage": {
    "backButtonTravelExtras": "Travel extras"
  }
}
